export default "__VITE_ASSET__BravAQvz__"